<div class="register-container">
  @if (step !== RegistrationStep.registrationSuccess) {
  <div class="stepper">
    <div
      class="step step-one"
      [ngClass]="{ active: step === RegistrationStep.termsAndConditions }"
    ></div>
    <div
      class="step step-two"
      [ngClass]="{ active: step === RegistrationStep.personalDetails }"
    ></div>
  </div>
  }

  <div
    class="step-container terms-and-conditions"
    [ngClass]="{ show: step === RegistrationStep.termsAndConditions }"
  >
    <app-terms-and-conditions (continue)="step = $event"></app-terms-and-conditions>
  </div>

  <div
    class="step-container personal-details-form"
    [ngClass]="{ show: step === RegistrationStep.personalDetails }"
  >
    <app-personal-details></app-personal-details>
  </div>

  <div
    class="step-container success"
    [ngClass]="{ show: step === RegistrationStep.registrationSuccess }"
  >
    <app-registration-success></app-registration-success>
  </div>
</div>
